import { MarketingButtons } from "../../components/MarketingButtons";
import { PageContent } from "../../pages/templates/PageLayout";
import { exampleLinks } from "./exampleLinks";
import featureCards from "../featureCards";
import Images from "../images";

const data: PageContent = {
  style: "light",
  sections: [
    {
      type: "HeroSection",
      title: "Digital brand hub",
      subtitle: `Stop the barrage of asset requests. Gather all your brand assets and documentation in one central place, and empower your team to create on their own. [See an example](${exampleLinks.digitalBrandHub}).`,
      primaryButton: MarketingButtons.getStarted,
      secondaryButton: MarketingButtons.bookDemo,
      image: {
        src: Images.Solutions.brandHub_hero,
        alt: "Brand hub",
      },
    },
    {
      type: "MediaSection",
      title: "Achieve brand consistency at scale",
      subtitle:
        "Establish a single source of truth for your brand so you can tell your brand's unique story.",
      layoutDirection: "image-left",
      body: {
        style: "tabList",
        items: [
          {
            title: "A home for all your brand assets",
            body: "Product shots, logos, videos, fonts, colors and any other brand asset can be stored and managed in Lingo. ",
            image: {
              src: Images.Solutions.brandHub_allAssets,
              alt: "A home for all your brand assets",
            },
          },
          {
            title: "Content and Context. Together.",
            body: "Lingo is part document, part asset library. Add contextual information like usage guidelines right next to your assets to ensure they're used correctly. ",
            image: {
              src: Images.Solutions.brandHub_contentContext,
              alt: "Content and Context. Together.",
            },
          },
          {
            title: "Advanced custom branding",
            body: "Make your brand hub look and feel official by choosing a custom font, color and web link.",
            image: {
              src: Images.Solutions.brandHub_customBranding,
              alt: "Advanced custom branding",
            },
          },
          {
            title: "Self-serve",
            body: "Lingo's powerful search and automatic file conversion will empower your team members to find the file they need in the format and size they need, all without needing your help. ",
            image: {
              src: Images.Solutions.brandHub_selfServe,
              alt: "Self serve assets",
            },
          },
        ],
      },
    },
    {
      type: "CardSection",
      title: "More powerful features to build and manage your brand hub",
      footerButton: {
        link: "/product/features",
        text: "View all features",
        buttonStyle: "outline",
      },
      items: [featureCards.unlimitedKits, featureCards.customDomains, featureCards.brandPortal],
    },
    {
      type: "FaqSection",
      title: "Digital Branding Hub FAQ",
      faqs: [
        {
          question:
            "How is Lingo's Digital Brand Hub different from cloud storage like Google Drive or Dropbox?",
          answer:
            "Unlike traditional cloud storage, Lingo is built specifically for brand asset management. It provides flexible, searchable kits, visual previews, and built-in brand guidelines that ensures teams can find, use, and share assets without the chaos of scattered assets.",
        },
        {
          question: "Can different teams have access to different assets?",
          answer:
            "Yes! Lingo allows you to set user permissions at the kit or asset level, ensuring that each team — whether internal, external, or third-party partners — sees only the files they need while keeping everything else secure.",
        },
        {
          question: "How does Lingo keep our brand assets up to date?",
          answer:
            "Lingo ensures that teams always have access to the latest, approved assets by offering version control, real-time updates, and integrations with tools like Canva, Dropbox, and Google Drive. When an asset is updated in Lingo, everyone sees the most current version instantly.",
        },
        {
          question: "Can Lingo help us enforce brand guidelines across different teams?",
          answer:
            "Absolutely! Lingo combines assets and guidelines in one place, providing clear usage instructions alongside each file. This ensures that marketing teams, sales reps, and external partners all use brand assets correctly, reinforcing brand consistency.",
        },
        {
          question: "Can external partners and agencies access our Digital Brand Hub?",
          answer:
            "Yes! You can securely share brand kits with partners, franchisees, and agencies via public or private links, password-protected access, or permission-controlled portals, ensuring they always have the right assets without requesting files.",
        },
      ],
    },
    { type: "CtaSection" },
  ],
};

export default data;
